const ProgramsComponent = {
    data() {
        return {
            programs: [],
            loading: false,

            limit: 8,
            currentPage: 1,
            pagesCount: 1,
            rowsCount: 0,
        };
    },

    methods: {
        async getPrograms(page = 1) {
            this.loading = true;
            this.currentPage = page;
            this.pagesCount = 1;

            try {
                const response = await fetch(window.appConfig.routes.getPrograms, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        limit: this.limit,
                        page: page
                    })
                });

                const data = await response.json();

                if (data?.detail?.invalid_page) {
                    this.goToPage(data.detail.go_to_page);
                    return;
                }

                this.programs = data.data ?? [];
                this.pagesCount = data.detail?.pages_count ?? 1;
                this.rowsCount = data.detail?.rows_count ?? 0;

            } catch (error) {
                console.error(error);
                this.programs = [];
            } finally {
                this.loading = false;
            }
        },

        goToPage(page) {
            if (page === this.currentPage || this.loading) return;
            this.getPrograms(page);
        },

        formatPrice(price)
        {
            return new Intl.NumberFormat('ru-RU').format(
                Number(price || 0)
            );
        },
    },

    mounted() {
        this.getPrograms(1);
    },

    computed: {
        showLoading() {
            return this.loading;
        },

        showContent() {
            return !this.loading && this.programs.length > 0;
        },

        paginationPages() {
            return globalState.paginationPages( this.pagesCount, this.currentPage )
        }
    }
};

window.ProgramsComponent = ProgramsComponent;